export default "__VITE_ASSET__93fa733b__"